<div
    *ngIf="tenant"
    [ngClass]="{
        'tenantHier--tenant-info--current': tenant.tenantId === sharedData.UserData.tenant.ID_Tenant,
        'tenantHier--cursor-pointer': tenant.children?.length ?? 0 > 0,
    }"
    class="tenantHier--tenant-info"
    (click)="headerLink($event)">
    <div class="tenantHier--width60">
        <div [style.padding-left.px]="[15 * depth]" class="tenantHier--title-left">
            <i
                class="icon-ic-chevron-s1 icon-ic-chevron--expandable tenantHier__icon-container"
                [ngClass]="{
                    'tenantHier__icon-container--open': tenant.expanded,
                    'tenantHier--hidden': tenant && $any(tenant.children).length === 0,
                }">
            </i>

            <label
                class="tenantHier--name-container"
                [ngClass]="{
                    'tenantHier--name-container--current': tenant.tenantId === sharedData.UserData.tenant.ID_Tenant,
                    'tenantHier--cursor-pointer': tenant.children?.length ?? 0 > 0,
                }"
                [title]="tenant.name">
                {{ tenant.name }}</label
            >
        </div>
    </div>
    <div class="tenantHier--width40">
        <div
            [ngClass]="{ 'tenantHier--hidden': tenant.tenantId === sharedData.UserData.tenant.ID_Tenant || !tenant.metaAccess?.hasRoles }"
            class="tenantHier__count-container tenantHier__manage-container"
            (click)="switchTenant()">
            Manage
        </div>
        <div class="tenantHier__count-container" [ngClass]="{ 'tenantHier--hidden': ChildCount == 0 }">
            {{ ChildCount }}
        </div>
    </div>
</div>

<div *ngIf="tenant && $any(tenant.children).length > 0" [ngClass]="{ 'tenantHier--closed': !tenant.expanded }">
    <ng-container *ngFor="let childTenant of tenant.children">
        <app-sidebar2-subpanel-tenant [tenant]="childTenant" [depth]="depth < 5 ? depth + 1 : depth"> </app-sidebar2-subpanel-tenant>
    </ng-container>
</div>
